import { useEffect } from 'react'

interface Config {
    isValidating: boolean
    currentIdentifier: string
    targetIdentifier: string
    sectionClassName: string
}

const setSectionsIds = (sectionClassName: string) => {
    const sections = document.getElementsByClassName(sectionClassName)
    for (const section of sections) {
        for (const elementClass of section.classList) {
            if (elementClass.includes('id-')) {
                section.setAttribute('id', elementClass)
                break
            }
        }
    }
}

const useSectionsIds = ({
    isValidating,
    currentIdentifier,
    targetIdentifier,
    sectionClassName
}: Config): void => {
    useEffect(() => {
        if (!isValidating && currentIdentifier === targetIdentifier) {
            setSectionsIds(sectionClassName)
        }
    }, [currentIdentifier, isValidating, sectionClassName, targetIdentifier])
}

export default useSectionsIds
